import React from "react";
import { connect } from "react-redux";
import { Row, Col } from "reactstrap";
import ElementWrapper from "../../../components/element/ElementWrapper/ElementWrapper";
import { Droppable } from "react-beautiful-dnd";
import { elementConstants } from "../../../../constants/cms/form/element/element.constants";
import { content } from "../../../models/content";
import { securityHelper } from "../../../../helpers/securityHelper";
import SystemLabel from "../../../../system/SystemLabel/SystemLabel";
import "../../../style/ContentStyles.css";
import ElementDropItem from "../../../components/editor/ElementDropItem/ElementDropItem";

class ContentElements extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      elements: null
    };
  }
  restoreList = () => {
    const elements = Array.from(content);
    const newElements = elements.map(el => {
      const newEl = Object.assign({}, el);
      newEl.guid = securityHelper.createGuid();
      return newEl;
    });
    this.setState({ elements: newElements });
  };
  componentDidMount() {
    if (typeof this.props.getRef === "function") {
      this.props.getRef({
        restoreList: this.restoreList
      });
    }
    this.restoreList();
  }
  render() {
    const { elements } = this.state;
    if (!elements) return null;
    return (
      <div className="element-list-aside">
        <div style={{ margin: " 0px 2px" }}>
          <div
            style={{
              color: "#222",
              fontWeight: "600",
              fontSize: "10px",
              color: "rgb(81, 97, 103)",
              textTransform: "uppercase",
              borderBottom: "0px !important",
              wordBreak: "break-all",
              paddingBottom: '8px'
            }}
          >
            <SystemLabel name="ContentElements" />
          </div>
        </div>

        <Droppable  isDropDisabled={true} droppableId={"sidebar-labels"}>
          {provided => (
            <div ref={provided.innerRef}>
              <Row style={{ margin: "0px", width: "225px" }}>
                {elements.map((e, index) => {
                  return (
                    <Col key={index} style={{ padding: "0px", paddingBottom: "5px" }}>
                      <ElementWrapper
                        key={index}
                        id={`${elementConstants.CONTENT}:${e.id}:${e.guid}`}
                        index={index}
                      >
                        <ElementDropItem draggableId={`${elementConstants.CONTENT}:${e.id}:${e.guid}`} name={e.label} icon={e.icon} />
                      </ElementWrapper>
                    </Col>
                  );
                })}
              </Row>
            </div>
          )}
        </Droppable>
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    alert: state.alert,
    template: state.template,
    form: state.form
  };
}

export default connect(mapStateToProps)(ContentElements);
